import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Scroll-triggered reveal. Fades + slides content into view once.
export const Reveal = ({
  children,
  delay = 0,
  y = 28,
  duration = 0.6,
  className = "",
  as = "div",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Entrance reveal (animates on mount, for above-the-fold content).
export const Entrance = ({
  children,
  delay = 0,
  y = 24,
  duration = 0.7,
  className = "",
  as = "div",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
